import { Controller } from "remult";

@Controller("call-center-volunteer-group-methods")
export class CallCenterVolunteerGroupMethods {}
